import { render, staticRenderFns } from "./ProductStorageAndPricing.vue?vue&type=template&id=4dce47fe&scoped=true&lang=pug&"
import script from "./ProductStorageAndPricing.vue?vue&type=script&lang=ts&"
export * from "./ProductStorageAndPricing.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStorageAndPricing.vue?vue&type=style&index=0&id=4dce47fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce47fe",
  null
  
)

export default component.exports